import { gql } from "@apollo/client";

import IOperation from "api/IOperation";
/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

import { CompleteOrderPlacementMutation as CompleteOrderPlacementMutationType, CompleteOrderPlacementMutationVariables } from "gql/types/mutations/CompleteOrderPlacementMutation";

const text = gql`mutation CompleteOrderPlacementMutation($completeOrderPlacement: MutationCompleteOrderPlacementInput!) {
	completeOrderPlacement(completeOrderPlacementInput: $completeOrderPlacement) {
		order {
			id
		}
	}
}
`;

const CompleteOrderPlacementMutation: IOperation<CompleteOrderPlacementMutationType, CompleteOrderPlacementMutationVariables> = { text } as any;

export default CompleteOrderPlacementMutation;
